import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {

  private dbName = 'ePerearstikeskusAppDB';
  private storeName = 'pictures';

  constructor() {
    this.initializeDatabase();
  }

  private initializeDatabase(): void {
    const request = indexedDB.open(this.dbName, 1);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(this.storeName)) {
        db.createObjectStore(this.storeName, { keyPath: 'id' });
      }
    };

    request.onerror = (event) => {
      console.error('IndexedDB initialization error:', event);
    };
  }

  saveFile(id: string, data: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName);

      request.onsuccess = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        const putRequest = store.put({ id, data });

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = (err) => reject(err);
      };

      request.onerror = (event) => {
        reject(`Error saving file: ${event}`);
      };
    });
  }

  getFile(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName);

      request.onsuccess = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);

        const getRequest = store.get(id);

        getRequest.onsuccess = () => resolve(getRequest.result?.data || null);
        getRequest.onerror = (err) => reject(err);
      };

      request.onerror = (event) => {
        reject(`Error retrieving file: ${event}`);
      };
    });
  }

  deleteFile(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName);

      request.onsuccess = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        const deleteRequest = store.delete(id);

        deleteRequest.onsuccess = () => resolve();
        deleteRequest.onerror = (err) => reject(err);
      };

      request.onerror = (event) => {
        reject(`Error deleting file: ${event}`);
      };
    });
  }

  clearAll(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName);

      request.onsuccess = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        const clearRequest = store.clear();

        clearRequest.onsuccess = () => resolve();
        clearRequest.onerror = (err) => reject(err);
      };

      request.onerror = (event) => {
        reject(`Error clearing all files: ${event}`);
      };
    });
  }
}
